import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

// font family
// -apple-system, 'Prosto One', BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif, 'Protest Riot';

  body {
    margin: 0;
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    }

  // button {
  //   color: white;
  //   font-size: 14px;
  //   background-color: #004a80;
  //   border-radius: 5px;
  //   padding: 8px;
  //   border: none;
  //   text-align: center;
  //   width: 150px;
  //   &:hover {
  //       cursor: pointer;
  //   }
  // }

  // input {
  //   height: 20px;
  //   text-align: center;
  // }

  // input[type="date"] {
  //   height: 20px;
  //   padding: 2px;
  //   text-align: center;
  // }

  // textarea {
  //   border-radius: 5px;
  // }

  // select {
  //   text-align: center;
  //   background-color: white;
  //   padding: 4px;
  // }

  // p {
  //   margin: 0;
  // }

  // label {
  //   margin-right: 5px;
  // }

  // input {
  //   border-radius: 3px;
  //   border-width: 0.5px;
  // }

`;

export default GlobalStyle;